import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarClock, RefreshCcw } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate, rupiah } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { FibiLoading } from "../components/FibiLoading";

const label = (d) => (d < 0 ? `lewat ${-d} hari` : d === 0 ? "hari ini" : `${d} hari lagi`);
const tone = (d) => (d < 0 ? "text-rose-500" : d <= 1 ? "text-orange-500" : "text-amber-500");

export default function PppDueSoon() {
  const [rows, setRows] = useState(null);
  const [days, setDays] = useState(3);
  const [q, setQ] = useState("");
  const navigate = useNavigate();
  const load = () => { setRows(null); api.get("/ppp/jatuh-tempo", { params: { days } }).then((r) => setRows(r.data)).catch((e) => { toast.error(errMsg(e)); setRows([]); }); };
  useEffect(load, [days]); // eslint-disable-line
  const list = (rows || []).filter((r) => !q || `${r.name} ${r.customer} ${r.router_name}`.toLowerCase().includes(q.toLowerCase()));
  const lewat = list.filter((r) => r.days_left < 0).length;
  return (
    <div className="space-y-4" data-testid="ppp-due-page">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <h1 className="text-xl sm:text-2xl font-heading font-bold flex items-center gap-2"><CalendarClock className="w-6 h-6 text-amber-500" /> PPPoE Jatuh Tempo</h1>
          <p className="text-xs text-muted-foreground">Pelanggan PPPoE yang masa aktifnya habis dalam {days} hari ke depan atau sudah lewat (≤7 hari). Ketuk baris untuk membuka secret & ingatkan pelanggan.</p>
        </div>
        <Button variant="outline" size="sm" onClick={load} data-testid="ppp-due-refresh"><RefreshCcw className="w-4 h-4 mr-1.5" /> Muat ulang</Button>
      </div>
      <div className="flex gap-2 flex-wrap items-center">
        {[3, 7, 14].map((n) => (
          <button key={n} type="button" onClick={() => setDays(n)} className={`px-3 py-1.5 rounded-lg text-xs font-semibold border ${days === n ? "bg-amber-500 text-white border-amber-500" : "bg-card border-border text-muted-foreground hover:text-foreground"}`} data-testid={`ppp-due-days-${n}`}>≤ {n} hari</button>
        ))}
        <span className="text-xs text-muted-foreground" data-testid="ppp-due-count">{rows ? `${list.length} pelanggan • ${lewat} sudah lewat` : "Memuat…"}</span>
        <Input placeholder="Cari secret / nama / cabang…" value={q} onChange={(e) => setQ(e.target.value)} className="h-8 w-64 ml-auto" data-testid="ppp-due-search" />
      </div>
      <div className="rounded-xl border border-border bg-card overflow-x-auto">
        <Table className="text-xs">
          <TableHeader><TableRow><TableHead>Secret</TableHead><TableHead>Pelanggan</TableHead><TableHead>Cabang</TableHead><TableHead className="text-right">Tarif</TableHead><TableHead>Berlaku s/d</TableHead><TableHead className="text-right">Sisa</TableHead></TableRow></TableHeader>
          <TableBody>
            {rows === null ? <TableRow><TableCell colSpan={6} className="p-0"><FibiLoading text="FIBI sedang memuat data..." size={20} /></TableCell></TableRow>
              : !list.length ? <TableRow><TableCell colSpan={6} className="text-center py-8 text-muted-foreground">Tidak ada pelanggan jatuh tempo</TableCell></TableRow>
              : list.map((r) => (
                <TableRow key={`${r.router_id}:${r.name}`} className="cursor-pointer hover:bg-muted/40" onClick={() => navigate(`/ppp?router=${encodeURIComponent(r.router_id)}&secret=${encodeURIComponent(r.name)}`)} data-testid={`ppp-due-row-${r.name}`}>
                  <TableCell className="font-mono font-semibold">{r.name}</TableCell>
                  <TableCell>{r.customer || "-"}</TableCell>
                  <TableCell>{r.router_name}</TableCell>
                  <TableCell className="text-right font-mono">{r.price ? rupiah(r.price) : "-"}</TableCell>
                  <TableCell className="font-mono">{fmtDate(r.expired_date)}</TableCell>
                  <TableCell className={`text-right font-bold whitespace-nowrap ${tone(r.days_left)}`}>{label(r.days_left)}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
